import ConfigurationHelper from "../configuration/ClientConfigurationHelper";

const VIDEO_URL_PART = "v";
const PHOTO_URL_PART = "p";
const STANDARD_CHANNEL_URL_PART = "c";
const DYNAMIC_CHANNEL_URL_PART = "c";

const entityIdToAssetUrlPartMap = {
    '1': VIDEO_URL_PART,
    '7': PHOTO_URL_PART,
    '5': STANDARD_CHANNEL_URL_PART,
    '3': DYNAMIC_CHANNEL_URL_PART
};

class Common {
    constructor() {
        this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        this.isIOS = navigator.userAgent.match(/ipad|iphone/i)
    }

    getProductsEndpoint(asset) {
        return `${ConfigurationHelper.getGlobalConfiguration().newApiBaseUrl}/entity/${asset.loginId ? asset.loginId : ConfigurationHelper.getGlobalConfiguration().loginId}/entity/${asset.id}/products`
    }

    getRecommendedProductsEndpoint(asset) {
        return `${ConfigurationHelper.getGlobalConfiguration().apiUrl}videos/${asset.id}/products`
    }

    createProductStructureData(productToEvaluate) {
        const product = !!productToEvaluate.entity ? {...productToEvaluate.entity, ...productToEvaluate.entity.data} : productToEvaluate;
        const hasPrice = !!product.price;

        const price = hasPrice ? ((product.price !== "N/A") ? product.price.toString().replace("USD", "") : 0) : 0;

        let schemaStructure = {
            "@context": "http://schema.org/",
            "@type": "Product",
            "name": product.title,
            "image": [
                product.data.imageUrl
            ],
            "description": product.description || "No Description",
            "mpn": product.referenceId || product.mpn,
            "sku": product.referenceId,
            "category": product.data.category,
            "brand": product.data.brand,
            "offers": {
                "@type": "AggregateOffer",
                "price": price,
                "lowPrice": price,
                "highPrice": price,
                "priceCurrency": "USD",
                "url": product.data.linkUrl,
                "availability": price === 0 ? "http://schema.org/OutOfStock" : "http://schema.org/InStock"
            }
        };
        this.injectStructureData(schemaStructure);
    }

    reverseStr = (s) => s.split("").reverse().join("");

    setCustomCookie(ambassador){
        const cookieName = 'aos-referrer-commissions';
        const employeeIdValue = (ambassador && ambassador.employee_id) ? `r=${encodeURIComponent(btoa(this.reverseStr(ambassador.employee_id)))}` : '';
        const storeNumberIdValue = (ambassador && (ambassador.store && ambassador.store.store_number)) ? `z=${ambassador.store.store_number}` : '';
        const cookieValue = `${employeeIdValue}|${storeNumberIdValue}|s=creatable`;
        const getCookie = this.getCookie(cookieName);
        if(!getCookie || getCookie !== cookieValue)  this.setCookie(cookieName, cookieValue);
    }

    setCookie(name,value,days = 7) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        return document ? document.cookie = name + "=" + (value || "")  + expires + "; path=/; secure;" : console.warn('error setting cookie!');
    }

    getCookie(name) {
        let nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for(let i=0;i < ca.length;i++) {
            let c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    getApiUrl(asset, isAmbassador, getRelated) {
        if (!asset) return null;

        const baseApi = `${ConfigurationHelper.getGlobalConfiguration().apiUrl}channels/${ConfigurationHelper.getRelatedVideosChannelId()}/contents`;
        if(getRelated) return baseApi;

        let url;
        if (isAmbassador) {
            url = `?user_id=${asset.owner.id}`;
        } else if (asset && (asset.matched && asset.matched.length)) {
            url = `${baseApi}?category=${escape(asset.matched[0].data.category)}`;
        } else {
            url = `${ConfigurationHelper.getGlobalConfiguration().apiUrl}channels/${ConfigurationHelper.getLatestVideosChannelId()}/contents`;
        }

        return url;
    }

    getNewApiUrl(id= null, isAmbassador = false) {
        const {apiBaseUrlV3, clientHash} = ConfigurationHelper.getGlobalConfiguration();
        let newChannelApiUrl = `${apiBaseUrlV3}/channel/${clientHash}/post?entity_type=video%2Cphoto`;

        const channelParams = {
            "order_by": "date_created",
            "order":"desc",
            ...isAmbassador ? {"show_on_storefront": "yes"} : {"show_on_grid":"yes"},
            ...id && {"user_id":id}
        };

        for (let param in channelParams) newChannelApiUrl += '&' + param + '=' + channelParams[param];
        return newChannelApiUrl;
    }
    getContentApiUrl() {
        return ConfigurationHelper.getContentSearchUrl();
    }

    getAssetStructureData(asset) {
        const title = asset.title;
        if (asset.data && typeof asset.data !== "object")
            asset.data = JSON.parse(asset.data)
        if (!asset.data && asset.asset) {
            asset.data = {};
            asset.data.asset = asset.asset;
        }
        asset.titleTextEncoded = asset.data.titleTextEncoded;
        const description = asset.description;
        const domain = "https://" + window.location.host;
        const target = domain + this.getVideoPageUrl(asset);
        let thumbnailUrl = this.urlProtocolFixer(asset.data.asset.thumbnailUrl);
        let schemaStructure = {
            "@context": "http://schema.org/",
            "@type": "VideoObject",
            "name": title,
            "thumbnailUrl": thumbnailUrl,
            "description": description,
            "uploadDate": this.getDateFromUnix(asset.date_created),
            "PotentialAction": {
                "@type": "ViewAction",
                "Target": target
            }
        };
        if (asset.entityType == 1) {
            schemaStructure.duration = this.formatDuration(asset.data.asset.prettyDuration);
            if (asset.data && asset.data.transcripts && asset.data.transcripts.length > 0) {
                schemaStructure.transcript = asset.data.transcripts;
            }
            // Google doesn't support dash encoded videos on structured data
            if (asset.data.asset.hlsUrl)
                schemaStructure.contentUrl = this.urlProtocolFixer(asset.data.asset.hlsUrl);
            else if (asset.data.asset.sources && asset.data.asset.sources.length > 0)
                schemaStructure.contentUrl = this.urlProtocolFixer(asset.data.asset.sources[0].file);
            else if (asset.data.asset.type === "youtube")
                schemaStructure.contentUrl = "https://www.youtube.com/watch?v=" + asset.data.asset.videoId;
        }


        return schemaStructure;
    }

    createAssetStructureData(asset) {
        if (!asset) return;
        const structureData = this.getAssetStructureData(asset);
        this.injectStructureData(structureData);
    }

    formatDuration(duration) {
        if (!duration) return;
        let output = "PT";
        const durationArray = duration.split(":");
        const hour = durationArray[0] ? parseInt(durationArray[0]) : 0;
        const minute = durationArray[1] ? parseInt(durationArray[1]) : 0;
        const seconds = durationArray[2] ? parseInt(durationArray[2]) : 0;
        if (hour > 0)
            output += hour + "H";
        if (minute > 0)
            output += minute + "M";
        if (seconds > 0)
            output += seconds + "S";
        return output;

    }

    urlProtocolFixer(url) {
        if (url && url.indexOf("http") === -1)
            url = "https:" + url;
        return url;
    }

    injectStructureData(structureData) {
        let schema = document.createElement("script");
        schema.type = "application/ld+json";
        schema.innerHTML = JSON.stringify(structureData);
        document.head.appendChild(schema);
    }

    highlightQuery(text, query) {
        let result = '';
        const index = text.indexOf(query);
        result += text.substring(0, index) + '<span class="suggest-highlight">' + text.substring(index, index + query.length) + '</span>' + text.substring(index + query.length);
        return result;
    }

    isEmpty(obj) {
        for (let key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    activeCategory(menu) {
        if (!menu) return;

        let category = null;
        for (let i = 0; i < menu.length; i++) {
            if (location.href.indexOf(menu[i].label.trim().replace(/[^A-Z0-9]+/ig, '-').toLowerCase()) > -1) {
                category = menu[i];
                break;
            }
        }
        return category;
    }

    isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    getVideoPageUrl(video) {
        let videoTitle;
        if(video.hasOwnProperty("titleTextEncoded")){
            videoTitle = video.titleTextEncoded;
        }else if(video.hasOwnProperty("data") && typeof video.data === 'object'){
            videoTitle = video.data.titleTextEncoded;
        }else if(video.hasOwnProperty("data") && typeof video.data === 'string'){
            const data = JSON.parse(video.data);
            videoTitle = data.titleTextEncoded
        }
        const formedUrl = ConfigurationHelper.getGlobalConfiguration().sub_folder + "/v/" + videoTitle.toString() + "/" + video.id + "/";
        return formedUrl.toLowerCase();
    }

    getDateFromUnix(unixDate) {
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const d = (new Date(Number(unixDate) * 1000));
        const month = months[d.getMonth()];
        const day = '' + d.getDate() + ',';
        const year = d.getFullYear();
        return [month, day, year].join(' ');
    }

    getDateFromUnixSearchFormat(unixDate) {
        const d = (new Date(Number(unixDate) * 1000));
        const month = d.getMonth();
        const day = d.getDate();
        const year = d.getFullYear();
        return [month, day, year].join('/');
    }

    getVideoTime(secs) {
        const date = new Date(0, 0, 0);

        date.setSeconds(Number(secs));

        const hour = (date.getHours() ? date.getHours() : '');
        const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        const seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();

        return (hour ? hour + ":" : "") + minutes + ':' + seconds;

    }

    rowerize(data, per, offset) {
        if (data) {
            const raw = data.slice(0);
            let rows = [],
                tries = 0,
                times = 5;

            while (raw.length) {
                tries++;
                if (tries === 2 && times !== 0 && offset) {
                    const offsetArr = raw.splice(0, per || 5);
                    let offsetRow = [],
                        offsetTemp = [];
                    for (let i = 0; i < offsetArr.length; i++) {
                        if (i === 0) {
                            offsetRow.push(offsetArr[i]);
                        } else {
                            offsetTemp.push(offsetArr[i])
                        }
                    }
                    offsetRow.push(offsetTemp);
                    rows.push(offsetRow);
                    times--;
                } else {
                    rows.push(raw.splice(0, per || 4));
                }
            }
            return rows;
        }
    }

    linkfy(text) {
        if (text) {
            text = text.replace(
                /((https?\:\/\/)|(www\.))(\S+)(\w{2,4})(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/gi,
                function (url) {
                    let full_url = url;
                    if (!full_url.match('^https?:\/\/')) {
                        full_url = 'http://' + full_url;
                    }
                    return '<a href="' + full_url + '">' + url + '</a>';
                }
            );
        }
        return text.replace(/\n/g, '<br>\n');
    }

    getById(id) {
        return document.getElementById(id);
    }

    isUndefined(o) {
        return 'undefined' === typeof o;
    }

    isFunction(o) {
        return 'function' === typeof o;
    }

    compact(o) {
        for (let k in o)
            if (o.hasOwnProperty(k) && !o[k])
                delete o[k];

        return o;
    }

    globalPoll(globs, callback) {
        globs = (globs || []).filter(Boolean);
        const that = this;
        const globsLength = globs.length;
        let globsCheck = 0;

        (function poll() {
            setTimeout(function () {
                let ready = true;
                let missing;

                for (let i = 0; i < globsLength; i++) {
                    let glob = globs[i];

                    if (undefined === window[glob]) {
                        ready = false;

                        missing = glob;
                    }
                }

                if (ready) {
                    if (that.isFunction(callback))
                        callback();
                } else if (++globsCheck < 10000) {
                    poll();
                } else {
                    throw new Error("missing global: " + missing);
                }
            }, 10);
        }());
    }

    getPostedDate(time) {
        if (!time)
            return;

        const templates = {
            prefix: "",
            suffix: " ago",
            seconds: "Just Now",
            minute: "Just Now",
            minutes: "%d minutes",
            hour: "%d hour",
            hours: "%d hours",
            day: "%d day",
            days: "%d days",
            month: "%d month",
            months: "%d months",
            year: "d% year",
            years: "%d years"
        };

        const template = function (t, n) {
            return templates[t] && templates[t].replace(/%d/i, Math.abs(Math.round(n)));
        };

        time = time.toString();
        time = time.replace(/\.\d+/, ""); // remove milliseconds
        time = time.replace(/-/, "/").replace(/-/, "/");
        time = time.replace(/T/, " ").replace(/Z/, " UTC");
        time = time.replace(/([\+\-]\d\d)\:?(\d\d)/, " $1$2"); // -04:00 -> -0400
        time = new Date(time * 1000 || time);

        const now = new Date();
        const seconds = ((now.getTime() - time) * .001) >> 0;
        const minutes = seconds / 60;
        const hours = minutes / 60;
        const days = hours / 24;
        const years = days / 365;

        return templates.prefix + (
            seconds < 45 && template('seconds', seconds) ||
            seconds < 90 && template('minute', 1) ||
            minutes < 45 && template('minutes', minutes) ||
            minutes < 90 && template('hour', 1) ||
            hours < 24 && template('hours', hours) ||
            hours < 42 && template('day', 1) ||
            days < 30 && template('days', days) ||
            days < 45 && template('month', 1) ||
            days < 365 && template('months', days / 30) ||
            years < 1.5 && template('year', 1) ||
            template('years', years)
        ) + templates.suffix;
    }

    debounce(func, wait, immediate) {
        let timeout;
        return function () {
            let context = this, args = arguments;
            let later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            let callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    generateAssetUrlFrom = (asset) => {
        if(asset.uri_stem){
            return `${ConfigurationHelper.getGlobalConfiguration().sub_folder}${asset.uri_stem}`
        }
        if(asset.page_url){
            return asset.page_url;
        }
        const assetType = entityIdToAssetUrlPartMap[asset.entityType];
        const assetTitle = this.extractTitleTextEncodedFrom(asset);
        return `${ConfigurationHelper.getGlobalConfiguration().sub_folder}/${assetType}/${assetTitle}/${asset.id}`
    }
    extractTitleTextEncodedFrom = (asset) => {
        const hasTitleTextEncoded = "titleTextEncoded" in asset;
        if (hasTitleTextEncoded) {
            return asset.titleTextEncoded;
        } else if (!hasTitleTextEncoded && typeof asset.data === "string") {
            return JSON.parse(asset.data).titleTextEncoded;
        } else if (!hasTitleTextEncoded && typeof asset.data === "object") {
            return asset.data.titleTextEncoded;
        }
    }
    hasAssetDataBlob = (asset) => {
        return asset && asset.asset;
    }

    isPhoto(asset) {
        return asset.entityType === 7;
    }

    getThumbnail(asset, height = 720) {
        if (asset.entityType === 1) {
            if (asset.asset && asset.asset.video && Array.isArray(asset.asset.video.thumbnails)) {
                // Sort thumbnails by height ascending
                const sorted = asset.asset.video.thumbnails.slice().sort((a, b) => a.height - b.height);
                // Find the first thumbnail with height >= requested
                for (let i = 0; i < sorted.length; i++) {
                    if (sorted[i].height >= height) {
                        return sorted[i].url;
                    }
                }
                // If none matched, return the largest
                return sorted[sorted.length - 1].url;
            }
        }
        // For photos (entityType 7)
        if (asset.entityType === 7) {
            if (asset.asset && asset.asset.photo && Array.isArray(asset.asset.photo.thumbnails)) {
                // Sort thumbnails by height ascending
                const sorted = asset.asset.photo.thumbnails.slice().sort((a, b) => a.height - b.height);
                // Find the first thumbnail with height >= requested
                for (let i = 0; i < sorted.length; i++) {
                    if (sorted[i].height >= height) {
                        return sorted[i].url;
                    }
                }
                // If none matched, return the largest
                return sorted[sorted.length - 1].url;
            }
        }
        // Fallback: return empty string
        return "";
    }
    setEnvForShortUrl(shortUrl){
        if(TVSite.phpEnvName === "stage" || TVSite.phpEnvName === "test"){
            if(shortUrl.includes("stage.tvp") || shortUrl.includes("test.tvp")){
                return shortUrl;
            }else{
                return shortUrl.replace("tvp.", `${TVSite.phpEnvName}.tvp.`)
            }
        }else{
            return shortUrl;
        }

    }
    getProductLink(product, assetId, userHashId){
        if(ConfigurationHelper.useAffiliateProductsLink() && userHashId && product.shortUrl){
            const pkAnalyticEvent = `?rt=pk&vd=${assetId}&ct=${product.id}`;
            return this.setEnvForShortUrl(product.shortUrl)+userHashId+pkAnalyticEvent;
        }else{
            return product.linkUrl;
        }
    }

    generateAmbassadorUrl = ambassador => {
        if (!ambassador) return "";
        if (ambassador.titleTextEncoded && typeof ambassador.titleTextEncoded == "string")
            return `${ConfigurationHelper.getGlobalConfiguration().sub_folder}/a/${ambassador.titleTextEncoded.toLowerCase()}/${ambassador.user_id}`;
        else if (ambassador.user_slug && typeof ambassador.user_slug == "string")
            return `${ConfigurationHelper.getGlobalConfiguration().sub_folder}/a/${ambassador.user_slug}/${ambassador.user_id}`;
    }
}

export default new Common();
